import { Button } from "@repo/ui/components/ui/button";
import { Input } from "@repo/ui/components/ui/input";
import { Search, X } from "lucide-react";
import { forwardRef } from "react";

interface DataTableSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
  className?: string;
}

const DataTableSearch = forwardRef<HTMLInputElement, DataTableSearchProps>(
  function DataTableSearch(
    { value, onChange, placeholder = "Rechercher...", id, className },
    ref
  ) {
    return (
      <div className={`relative w-full sm:w-96 ${className ?? ""}`.trim()}>
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          ref={ref}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="pl-9 bg-background/60 backdrop-blur-sm border-border focus:border-primary transition-all"
        />
        {value && (
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 transform -translate-y-1/2 h-7 w-7 text-muted-foreground hover:text-foreground"
            onClick={() => onChange("")}
            aria-label="Effacer la recherche"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    );
  }
);

export default DataTableSearch;
